module.exports = __webpack_public_path__ + "img/82.dd175460.jpg";